module.exports = __webpack_public_path__ + "img/task-10-l.0f226844.png";